import * as React from 'react';
import { FC } from 'react';
import classnames from 'classnames';
import type { Locales } from 'app/helpers/createLocalesContext';
import { translation } from 'app/helpers/createLocalesContext';

const SubmitButton: FC<{ isSubmitting: boolean; isValid: boolean; locales: Locales }> = ({
  isSubmitting,
  isValid,
  locales,
}) => {
  const disabled = !isValid || isSubmitting;

  return (
    <div className="sign_button-wrap">
      <div className="rs-text-align_center">
        <button
          type="submit"
          id="submit"
          disabled={!isValid || isSubmitting}
          className={classnames({ disabled }, 'rs-button rs-button_double-size red sign_button xo-button')}
        >
          {translation(locales, isSubmitting ? 'disable_with' : 'submit')}
        </button>
      </div>
    </div>
  );
};

export default SubmitButton;
